<div class="card-body select-options">
  <div *ngFor="let item of descriptions" class="noselect">
    <div class="form-check select-list-item">
      <input type="radio" class="form-check-input" name="customRadio" [id]="'customRadio_' + item.description" [(ngModel)]="selected" [value]="item.value" (ngModelChange)="selectedChange.emit(selected)">
      <label class="form-check-label pointer" [for]="'customRadio_' + item.description">{{item.description}}</label>
    </div>
  </div>
</div>
